import { Component, h, Host, Prop } from '@stencil/core';
export class Skeleton {
  constructor() {
    this.items = [];
    /**
     * Number of skeleton children to render in component
     */
    this.count = 1;
    /**
     * Animation type
     */
    this.animation = 'shimmer';
    /**
     * Direction to render skeleton children in component
     */
    this.direction = 'column';
  }
  componentWillRender() {
    this.items = new Array(this.count);
    this.items.fill(1);
  }
  render() {
    return (h(Host, { style: { '--sy-skeleton-direction': this.direction } }, this.items.map((_, index) => {
      return (h("span", { key: index, style: {
          [this.direction === 'row' ? '--sy-skeleton-count-width' : '--sy-skeleton-count-height']: String(this.count),
        }, class: {
          [this.animation]: true,
        }, "aria-busy": "true", "aria-valuemin": "0", "aria-valuemax": "100", "aria-valuetext": "Loading...", role: "progressbar", tabIndex: 0 }));
    })));
  }
  static get is() { return "sy-skeleton"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "count": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Number of skeleton children to render in component"
      },
      "attribute": "count",
      "reflect": false,
      "defaultValue": "1"
    },
    "animation": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'shimmer' | 'pulse' | 'none'",
        "resolved": "\"none\" | \"pulse\" | \"shimmer\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Animation type"
      },
      "attribute": "animation",
      "reflect": false,
      "defaultValue": "'shimmer'"
    },
    "direction": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'row' | 'column'",
        "resolved": "\"column\" | \"row\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Direction to render skeleton children in component"
      },
      "attribute": "direction",
      "reflect": false,
      "defaultValue": "'column'"
    }
  }; }
}
//# sourceMappingURL=skeleton.js.map